"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RtfOldListLevelInfo = void 0;
var character_properties_1 = require("../../../../core/model/character/character-properties");
var font_info_1 = require("../../../../core/model/fonts/font-info");
var list_level_properties_1 = require("../../../../core/model/numbering-lists/list-level-properties");
var RtfOldListLevelInfo = (function () {
    function RtfOldListLevelInfo() {
        this.characterProperties = new character_properties_1.MaskedCharacterProperties();
        this.characterProperties.fontInfo = new font_info_1.FontInfo();
        this.characterProperties.fontSize = 12;
        this.characterProperties.setAllUse();
        this.listLevelProperties = new list_level_properties_1.ListLevelProperties();
        this.textBefore = "";
        this.textAfter = "";
        this.indent = 0;
    }
    RtfOldListLevelInfo.prototype.clone = function () {
        return null;
    };
    RtfOldListLevelInfo.prototype.copyFrom = function (_obj) {
    };
    return RtfOldListLevelInfo;
}());
exports.RtfOldListLevelInfo = RtfOldListLevelInfo;
